import {
    ConditionalContent,
    ConditionRadio,
    ContentElement,
    createStore,
    DatePicker,
    FileUpload,
    FormGridRow,
    FormVue,
    HiddenfieldHoneypot,
    MaskedText,
    OnCaptcha,
    OnCheckBox,
    OnRadioGroup,
    OnTextArea,
    OnTextfieldEmail,
    OnTextfieldNumber,
    OnTextfieldText,
    registerResponseInterceptor,
    SelectWithRelatedData,
    StaticText,
} from 'formvue-json';

import CustomMultiStepForm from "./customElements/CustomMultiStepForm.vue";
import StaticCondition from "./customElements/StaticCondition.vue";
import NotEmptyCondition from "./customElements/NotEmptyCondition.vue";

import IbanValidator from './validators/IbanValidator';
import * as RequiredIfValidator from './validators/RequiredIf';

import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from 'vuetify/lib/framework';
import {checkOamDefaultValue, handleOamStepChange, interceptOamGaPV, interceptOamMatomoPV} from "./util/oam";
import {addFormDataToLayer, trackGaPageView, trackMatomoPageView} from "./util/pageViews";
import {DomHelper} from "../general/utils";
import {setDefaultValue} from "./util/formUtils";
import {transformFormSchema} from "./sds/formTransformation";
import SdsTelephone from "./customElements/SdsTelephone.vue";

// configure Vue
Vue.use(Vuex);
Vue.use(Vuetify);


/**
 *
 * @param {HTMLElement} content
 *
 * @returns {HTMLElement | undefined}
 */
function openContentInModal(content) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('modal', 'active');

    const modalHtml = `
        <div class="modal-content">
            <div class="modal-close-wrapper">
                <div class="modal-close on-icon-close"></div>
            </div>
            <div class="modal-content-inner">
                ${content.outerHTML}
            </div>
        </div>
    `
    wrapper.innerHTML = modalHtml;

    const modalClose = wrapper.querySelector('.modal-close-wrapper');
    if (!modalClose) return;

    modalClose.addEventListener('click', (e) => {
        DomHelper.enablePageScroll('has-overlay');
        document.body.removeChild(wrapper);
    })

    DomHelper.stopPageScroll('has-overlay');
    document.body.appendChild(wrapper);

    return wrapper;
}

/**
 *
 * @param {MouseEvent} e
 * @returns {Promise<void>}
 */
async function modalLinkHandler(e){
    e.preventDefault();
    const href=e.target.href;
    if(!href) return;
    const loadingElement = document.createElement('div');
    loadingElement.classList.add('loading-wrapper');
    loadingElement.innerHTML=`<div class="loading-indicator"></div>`

    const modal = openContentInModal(loadingElement);
    if (!modal) return;

    try {

        const res = await fetch(href);
        const content = await res.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');

        const docContentSections = doc.querySelectorAll('section.row');

        if (!docContentSections) return;

        const modalContent=modal.querySelector('.modal-content-inner');
        if(modalContent){
            modalContent.innerHTML="";
            for(let contentSection of docContentSections){
                modalContent.innerHTML+=contentSection.outerHTML;
            }
        }else{
            modal.remove();
            DomHelper.enablePageScroll('has-overlay');
        }

    } catch (e) {
        console.error(e)
        modal.remove();
        DomHelper.enablePageScroll('has-overlay');
    }

}



function initModalLinks() {
    const triggers = document.querySelectorAll('[data-dialog]');

    for (const trigger of triggers) {
        trigger.removeEventListener('click', modalLinkHandler)
        const href = trigger.href;
        if (!href) continue;

        trigger.addEventListener('click', modalLinkHandler)
    }
}

function initFormPopup() {
    const formModal = document.querySelector('.form-modal');
    if (!formModal) return;

    const cookies = document.cookie.split(';');
    if (cookies.some(cookie => cookie.trim() === "formModalOpened=true")) {
        formModal.remove();
        return;
    }

    const openFormModal = () => {
        if (!popUnderShouldShow || window.innerWidth < 768) return;

        // check for other forms on current page (there are always 2 forms, because of the popunder)
        if (window.extendedforms && Object.keys(window.extendedforms).length > 2 && window.location.pathname !== '/') return;

        const modalClose = formModal.querySelector('.modal-close-wrapper');
        if (!modalClose) return;

        if (document.body.classList.contains('overflowHidden') || document.body.style.overflow === 'hidden' || document.body.classList.contains('has-overlay')) {
            return;  // do not open this modal too when other modals are open
        }

        modalClose.addEventListener('click', () => {
            DomHelper.enablePageScroll('has-overlay');

            formModal.remove();
            document.removeEventListener('click', openFormModal);

        })


        formModal.querySelectorAll('[data-id]').forEach(formWrapper=>{
            const id = formWrapper.getAttribute('data-id');
            const wrapper = document.querySelector('[data-id="' + id + '"]');
            if(!wrapper) return;

            const formConfigsList = window.extendedforms;

            if(!formConfigsList) return;

            const formSchema=formConfigsList[id];

            if(!formSchema) return;

            mountForm(id, formSchema, wrapper);
        })


        formModal.classList.add('active');
        DomHelper.stopPageScroll('has-overlay');

        document.cookie = "formModalOpened=true; max-age=" + 30 * 24 * 60 * 60; // 30 days

        // track popunder pv
        const currentUrl = window.location.toString();
        const pvUrl = currentUrl.substring(0, currentUrl.length - window.location.pathname.length) + '/popunder/';
        const pvTitle = 'Jetzt gratis Infopaket anfordern! | Schule des Schreibens';
        SDS.Utils.trackPageView(pvUrl, pvTitle);
        trackGaPageView(pvUrl, pvTitle);
    }

    document.addEventListener('click', openFormModal);
}

function initSudOverlay() {
    const formModal = document.querySelector('.sud-modal');
    if (!formModal) return;

    const modalClose = formModal.querySelector('.modal-close-wrapper');
    if (!modalClose) return;

    modalClose.addEventListener('click', () => {
        formModal.remove();

        fetch('/ajax/sud-overlay-closed', { method: 'POST' }).then();
    })
}

let showNewsletter = true;

registerResponseInterceptor(async (ctx, json) => {
    if (!json || json.status !== 200) return;

    if (ctx?.state?.id === 'catalogFormPopunder-626') {
        // popunder was submitted

        const doneElement = document.querySelector('.catalogFormPopunder-done');

        if (doneElement) {
            doneElement.hidden = false;
        }

        const formId = "nachfass-auswahl-1360";
        const formSchema = window.extendedforms[formId];
        if (!formSchema) return;

        const model = ctx.getters?.getCurrentModel;

        if (model && model.email?.value) {
            setDefaultValue(formSchema, 'email', model.email.value);

            if (model['newsletter-check'] && model['newsletter-check'].value) {
                showNewsletter = false;  // already subscribed in the first step
            }
        }

        let wrapper = document.querySelector('[data-id="' + formId + '"]');
        if (wrapper) return;  // there is already a wrapper for the redirect form

        const oldFormView = formViews[ctx.state.id];
        const oldWrapper = oldFormView?.$el;
        /** @type {HTMLElement | undefined} */
        const container = oldWrapper?.parentElement;
        if (!container) return;

        // support callbacks before swapping forms
        try {
            await ctx.dispatch('handleResponseCallbacks', json);
            const callbackResponse = ctx.state.formResponse;
            if (callbackResponse && 'error' in callbackResponse && !!callbackResponse.error) {
                return;  // callback error, cancel
            }
        } catch (e) {
            console.error(e);
            return;
        }

        /** @type {HTMLElement} */
        const catalogFormTitle = container?.parentElement?.querySelector('.catalogFormPopunder-title');
        if (catalogFormTitle) {
          catalogFormTitle.remove();
        }

        // construct new wrapper besides old wrapper
        wrapper = document.createElement('div');
        wrapper.setAttribute('data-id', formId);
        container.appendChild(wrapper);

        mountForm(formId, formSchema, wrapper);

        // destroy old vue instance
        if (oldFormView && '$destroy' in oldFormView) {
            oldFormView.$destroy();
            delete formViews[ctx.state.id];
        }

        // remove oldWrapper from DOM
        if (oldWrapper) {
            container.removeChild(oldWrapper)
        }

        // track newsletter popunder url
        const currentUrl = window.location.toString();
        const pvUrl = currentUrl.substring(0, currentUrl.length - window.location.pathname.length) + '/popunder/gratis-infopaket-anfordern-erfolgreich/';
        const pvTitle = 'Gratis Infopaket anfordern - erfolgreich | Schule des Schreibens';
        SDS.Utils.trackPageView(pvUrl, pvTitle);
        trackGaPageView(pvUrl, pvTitle);

        return true;  // cancel further response handling
    }
    else if(ctx?.state?.id ==='catalogFormPopunder2-674'){

        const oldFormView = formViews[ctx.state.id];
        const oldWrapper = oldFormView?.$el;
        /** @type {HTMLElement | undefined} */
        const container = oldWrapper?.parentElement;
        if (!container) return;

        // support callbacks
        try {
            await ctx.dispatch('handleResponseCallbacks', json);
            const callbackResponse = ctx.state.formResponse;
            if (callbackResponse && 'error' in callbackResponse && !!callbackResponse.error) {
                return;  // callback error, cancel
            }
        } catch (e) {
            console.error(e);
            return;
        }

        // track popunder end pv
        const currentUrl = window.location.toString();
        const pvUrl = currentUrl.substring(0, currentUrl.length - window.location.pathname.length) + '/popunder/gratis-infopaket-anfordern-danke/';
        const pvTitle = 'Gratis Infopaket anfordern - Danke | Schule des Schreibens';
        trackMatomoPageView(pvUrl, pvTitle);
        trackGaPageView(pvUrl, pvTitle);
    }
    // nachfass-auswahl SUD
    else if (ctx?.state?.id ==='nachfass-auswahl-1120') {
        // support callbacks
        try {
            await ctx.dispatch('handleResponseCallbacks', json);
            const callbackResponse = ctx.state.formResponse;
            if (callbackResponse && 'error' in callbackResponse && !!callbackResponse.error) {
                return;  // callback error, cancel
            }
        } catch (e) {
            console.error(e);
            return;
        }

        const formModal = document.querySelector('.sud-modal');
        if (!formModal) return;

        formModal.remove();
    }
    // nachfass-auswahl popunder
    else if (ctx?.state?.id === "nachfass-auswahl-1360") {

        const oldFormView = formViews[ctx.state.id];
        const oldWrapper = oldFormView?.$el;
        /** @type {HTMLElement | undefined} */
        const container = oldWrapper?.parentElement;
        if (!container) return;

        // support callbacks
        try {
            await ctx.dispatch('handleResponseCallbacks', json);
            const callbackResponse = ctx.state.formResponse;
            if (callbackResponse && 'error' in callbackResponse && !!callbackResponse.error) {
                return;  // callback error, cancel
            }
        } catch (e) {
            console.error(e);
            return;
        }

        if (!showNewsletter) return;

        const modalContent = document.querySelector('.modal-content-inner');
        if (modalContent) {
            const title = document.createElement('h3');
            title.innerHTML = 'Newsletter';
            title.classList.add('overlay-title');
            modalContent.appendChild(title);
        }

        const formId = "catalogFormPopunder2-674";
        const formSchema = window.extendedforms[formId];
        if (!formSchema) return;

        let wrapper = document.querySelector('[data-id="' + formId + '"]');
        if (wrapper) return;  // there is already a wrapper for the redirect form

        // construct new wrapper besides old wrapper
        wrapper = document.createElement('div');
        wrapper.setAttribute('data-id', formId);
        container.appendChild(wrapper);

        mountForm(formId, formSchema, wrapper);
    }

})

initFormPopup();
initSudOverlay();

const formViews = {};

export default function initFormVue() {
    checkOamDefaultValue();

    const forms = document.querySelectorAll('[data-id]');
    const formConfigsList = window.extendedforms;

    if (!formConfigsList) return;

    const tryMountingFormsInViewport=()=>{
        for (let form of forms) {
            if(DomHelper.elementInViewport(form) && !form.dataset.mountingForm) {
                const id = form.getAttribute('data-id');
                const wrapper = document.querySelector('[data-id="' + id + '"]');

                if (!wrapper) continue;
                const formSchema = formConfigsList[id];
                mountForm(id, formSchema, wrapper);
            }

        }
    }

    tryMountingFormsInViewport()

    window.addEventListener('scroll', ()=>{
        tryMountingFormsInViewport()
    }, {passive: true})

    window.addEventListener('resize', ()=>{
        tryMountingFormsInViewport()
    })

    window.addEventListener('orientationchange', ()=>{
        tryMountingFormsInViewport()
    })
}



function scrollToError(inputWithError) {
    if (inputWithError) {
        let scrollTarget = inputWithError.getBoundingClientRect().top + window.scrollY;
        const offset = 300;
        scrollTarget -= offset;
        scrollTarget = scrollTarget > 0 ? scrollTarget : 0;
        window.scrollTo({
            top: scrollTarget,
            behavior: 'smooth'
        });
    }
}



function onStepChange(step, vueComponentContext) {
    const steps = vueComponentContext?.$store?.state?.steps;
    if (steps && Array.isArray(steps) && steps.length >= 1) {
        const seminar = steps[0]?.inputModel?.seminar?.value;
        if (typeof seminar === 'number') {
            handleOamStepChange(seminar);
        }
    }

    initModalLinks();

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });

}

function mountForm(id, formSchema, wrapper) {
    if (!formSchema || !formSchema.configuration) return;

    transformFormSchema(formSchema);

    wrapper.dataset.mountingForm=true;

    const store = createStore(Vuex, {
        formData: formSchema,
        callbacksMap: callbacks
    });

    formViews[id] = new Vue({
        vuetify: new Vuetify(vuetifyConfig),
        store: store,
        render: h => h(FormVue, {
            props: {
                formSchema,
                customMultiStepForm: CustomMultiStepForm,
                componentsMap: {
                    Text: OnTextfieldText,
                    Email: OnTextfieldEmail,
                    Number: OnTextfieldNumber,
                    Honeypot: HiddenfieldHoneypot,
                    Checkbox: OnCheckBox,
                    LinkedCheckbox: OnCheckBox,
                    SingleSelect: SelectWithRelatedData,
                    FileUpload: FileUpload,
                    StaticText: StaticText,
                    Textarea: OnTextArea,
                    Oncaptcha: OnCaptcha,
                    GridRow: FormGridRow,
                    ContentElement: ContentElement,
                    RadioButton: OnRadioGroup,
                    DatePicker: DatePicker,
                    ConditionRadio: ConditionRadio,
                    ConditionalContent: ConditionalContent,
                    MaskedText: MaskedText,
                    StaticCondition: StaticCondition,
                    NotEmptyCondition: NotEmptyCondition,
                    SdsTelephone: SdsTelephone
                },
                validatorsMap: {
                    IBAN: IbanValidator,
                    RequiredIf: RequiredIfValidator.create(store),
                },
                fieldPropsOverwrite: {
                    filled: true // force all vuetify inputs to be variant=filled
                },
                scrollIntoView: scrollToError,
                scrollToSuccessMessage: true,
                onStepChange: onStepChange
            }
        })
    }).$mount(wrapper);

    initModalLinks();
}

// create vuetify config
const vuetifyConfig = {
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        dark: false,
        themes: {
            light: {
                primary: "#1C1C1C",
                accent: "#dae5f4",
                error: "#990000"
            }
        }
    }
}

const callbacks = {
    defaultCallback: async(_, ctx)=>{
        if(ctx?.state?.formName){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'generate_lead',
                'form_name' : ctx.state.formName
            });
        }

    },
    MatomoTracking: async (cbArgs) => {
        if (!cbArgs || !cbArgs.goals)
            return console.warn("[MatomoTracking] could not find key goals in arguments")

        cbArgs.goals.forEach(goal => {
            if (typeof goal !== 'number') {
                console.warn(`[MatomoTracking] invalid goalId '${goal}'`);
            } else {
                SDS.Utils.trackMatomoGoal(goal.toFixed(0));
            }
        })
    },
    MatomoPV: async (cbArgs, ctx) => {
        if (!cbArgs)
            return console.warn("[MatomoTracking] no pv arguments")
        else if (!cbArgs.url)
            return console.warn("[MatomoTracking] could not find key url in arguments")
        else if (!cbArgs.title)
            return console.warn("[MatomoTracking] could not find key title in arguments")

        const {url, title} = cbArgs;

        if (title.length <= 0)
            return console.warn("[MatomoTracking] empty title supplied")

        if (!interceptOamMatomoPV(url, title, ctx)) {
            trackMatomoPageView(url, title);
        }
    },
    GoogleAnalyticsPV: async (cbArgs, ctx) => {
        if (!cbArgs)
            return console.warn("[GoogleAnalytics] no pv arguments")
        else if (!cbArgs.url)
            return console.warn("[GoogleAnalytics] could not find key url in arguments")
        else if (!cbArgs.title)
            return console.warn("[GoogleAnalytics] could not find key title in arguments")

        const {url, title} = cbArgs;

        if (title.length <= 0)
            return console.warn("[GoogleAnalytics] empty title supplied")

        if (!interceptOamGaPV(url, title, ctx)) {
            trackGaPageView(url, title);
        }
    },
    DataLayerCollector: async (cbArgs) => {
        if (!cbArgs)
            return console.warn("[DataLayerParams] no values")

        const { key, value } = cbArgs;

        addFormDataToLayer( key, value);
    },
};

initFormVue();
initModalLinks();

let popUnderShouldShow = true;
window.addEventListener('UC_UI_VIEW_CHANGED', event => {
    if (event.detail && event.detail.view) {
        popUnderShouldShow = event.detail.view === 'NONE';
    }
})
